import { Component } from '@angular/core';

@Component({
  selector: 'app-customer-interfoce-home-page',
  templateUrl: './customer-interfoce-home-page.component.html',
  styleUrls: ['./customer-interfoce-home-page.component.css']
})
export class CustomerInterfoceHomePageComponent {

}
